import { MoreInfo } from "../../MoreInfo/MoreInfo";
import { Image } from "../../../Image/Image";

export const FicheWetenschappelijkOnderzoek = (props) => {
  return (
    <div
      className={`c-fiche c-wetenschappelijk-onderzoek-full ${
        props.data?.hasDetail ? "u-has-detail" : ""
      }`}
      onClick={() => {
        if (props.data?.hasDetail && props.openPopup) {
          props.openPopup(props.data.urlSegment);
        }
      }}
      data-aos="fade-up"
    >
      <div>
        <div className="image" title="Meer over">
          {props.data?.image?.url && (
            <Image
              alt={props.data.image?.alt ?? ""}
              src={props.data.image.url}
            />
          )}
        </div>
        <header className="c-fiche__header">
          <h2 className="title" title={props.title}>
            {props.data.title}
          </h2>
        </header>
        <MoreInfo
          data={props.data}
          openPopup={props.openPopup}
          cta={props.dictionary.moreInfo}
        />
      </div>
    </div>
  );
};
